var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"node pl--20px",attrs:{"draggable":"true"},on:{"drag":function($event){$event.stopPropagation();return _vm.drag($event)}}},[_vm._v("\n    "+_vm._s(_vm.type)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }